module.exports = __webpack_public_path__ + "static/dashboard_unisafe@2x-1df4131cb173be27bc1ec0820ffd7e34.png";